export function config(
  state = {
    layout: 'default-sidebar',
    background: 'light',
    navbar: 'success',
    topNavigation: 'dark',
    logo: 'light',
    leftSidebar: 'dark',
    leftSidebarIcons: 'dark',
    rightSidebar: false,
    collapsed: false,
  },
  action
) {
  switch (action.type) {
    case 'SET_CONFIG':
      return Object.assign({}, state, {
        ...action.config,
      });
    default:
      return state;
  }
}
